<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16 container-large">
      <LoadingWidget v-if="loading" />

      <template v-else-if="items.length">
        <div class="justify-center grid-list">
          <GalleryCard
            v-for="(item, keyItems) in items"
            :key="keyItems"
            v-bind="item"
          />
        </div>

        <PaginationWidget
          v-if="countPages > 1"
          class="mt-10"
          :count="countPages"
        />
      </template>

      <v-alert v-else type="info">{{ noContentText }}</v-alert>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import GalleryCard from "../components/cards/GalleryCard.vue";
import PaginationWidget from "../components/widgets/PaginationWidget.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "galleries",
  path: "/galerias-de-fotos",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  title: "Galerias",
  loading: true,
  totalItems: 0,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, subtitle, date }) => ({
          img,
          title,
          subtitle,
          date,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
    page() {
      return this.$route.query.p;
    },
    countPages() {
      return Math.ceil(this.totalItems / _pagination.itemsPerPage);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (params.returnTotalItems) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            } else {
              state.list = data;
            }
          },
        })
        .catch(() => this.$router.replace({ path: "/erro404" }))
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    LoadingWidget,
    GalleryCard,
    PaginationWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 1279.9px) {
    gap: 20px;
  }

  @media screen and (max-width: 959.9px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 599.9px) {
    gap: 12px;
  }
}
</style>
